import { useContext } from "react";
import { UseQueryResult, useQuery } from "@tanstack/react-query";

import { AxiosContext } from "contexts/AxiosContext";
import { makeQueryString } from "core/makeQueryString";
import { AnnualKpi } from "interfaces/kpis";
import { PaginatedResponse } from "interfaces/utils";

interface CommonArgs {
  ordering?: string;
  page?: number;
  search?: string;
  size?: number;
  enabled?: boolean;
}

export interface CaseStreamFilterType {
  name: string;
  value: string;
}

const STALE_TIME = 1000 * 60 * 15;

export const useCaseStreamFilterTypesQuery = (
  args: CommonArgs = {}
): UseQueryResult<PaginatedResponse<AnnualKpi[]>, unknown> => {
  const { axios } = useContext(AxiosContext)!;

  const { enabled: isEnabled, ...qsArgs } = args;
  const enabled = isEnabled ?? true;

  const qs = makeQueryString(qsArgs);

  return useQuery({
    queryKey: ["case-stream", "filter-types", "all"],
    queryFn: async () => {
      const { data } = await axios.get<
        PaginatedResponse<CaseStreamFilterType[]>
      >(`/case-stream-filter-types${qs}`);

      return data;
    },
    staleTime: STALE_TIME,
    enabled
  });
};
